import {observer} from 'mobx-react';
import {QuickTip} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import {auth} from 'main/tools';
import _ from 'lodash';

function interviewersMissingConnections(schedule) {
  if (!schedule) return [];

  const users = (schedule.interviewers || []).filter(u => u.calendarAppConnected === false);
  if (schedule.location === 'video_conferencing' && schedule.meetingHost?.meetingAppConnected === false) {
    users.push(schedule.meetingHost);
  }

  return _.uniqBy(users, 'id');
}

const MissingIntegrationsWarning = observer(({schedule, pastTense = false}) => {
  const missingConnections = interviewersMissingConnections(schedule);
  if (_.isEmpty(missingConnections)) return null;

  const currentUserMissingConnections = _.some(missingConnections, {id: auth.user.id});
  const otherUsersMissingConnections = _.some(missingConnections, u => u.id !== auth.user.id);

  const paragraphs = [
    <FormattedMessage
      key='explainer'
      id='recruiting.interview_schedules.edit.interviewers.The following users have not connected their calendars and/or meeting apps to Collage:'
    />,
    <ul key='users-list' className='mb0'>
      {missingConnections.map(u => <li className='ml3' key={u.id}>{u.name}</li>)}
    </ul>,
    <FormattedMessage
      key='cannot-use'
      id='recruiting.interview_schedules.edit.interviewers.You will not be able to use this interview schedule until all users have set up their required integrations.'
    />
  ];

  if (otherUsersMissingConnections) {
    paragraphs.push(
      <FormattedMessage
        key='notified'
        id={pastTense ?
          'recruiting.interview_schedules.edit.interviewers.Users have been notified by email to connect these apps to Collage.' :
          'recruiting.interview_schedules.edit.interviewers.Users will be notified by email to connect these apps to Collage.'}
      />
    );
  }

  if (currentUserMissingConnections) {
    paragraphs.push(
      <FormattedMessage
        key='settings-link'
        id='recruiting.interview_schedules.edit.interviewers.USER_SETTINGS_LINK'
        values={{user_settings: <a href='/user_settings' target='_blank' rel='noreferrer'><FormattedMessage id='recruiting.interview_schedules.edit.interviewers.personal settings'/></a>}}
      />
    );
  }

  return (
    <div className='mb2'>
      <QuickTip
        trait='caution'
        header={<FormattedMessage id='recruiting.interview_schedules.edit.interviewers.Missing integrations'/>}
      >
        {paragraphs}
      </QuickTip>
    </div>
  );
});

export default MissingIntegrationsWarning;
